import React from 'react';
import Card from './card';
import './templates.css';
import surveyData from '../../../../assets/templates.json'


const Templates = ({ onTemplateSelect }) => {
    return (
        <div className="templates-container">
            {surveyData.saved_jsons.map((item, index) => {
                const { survey_name, survey, restart_word } = item;
                const description = Object.entries(survey)
                    .map(([key, value]) => {
                        const msgs = value.msgs ? value.msgs.join(' ') : '';
                        return `${key.toUpperCase()}: ${msgs}`;
                    })
                    .join('\n');

                return (
                    <Card
                        key={index}
                        title={survey_name}
                        desc={description}
                        onUse={() => onTemplateSelect({
                            survey_name,
                            restart_word,
                            survey
                        })}
                    />
                );
            })}
        </div>
    );
};

export default Templates;